import HIW1 from "../../assets/images/howitwork1.png";
import HIW2 from "../../assets/images/howitwork2.png";
import HIW3 from "../../assets/images/howitwork3.png";
import HIW4 from "../../assets/images/howitwork4.png";
import HIW5 from "../../assets/images/howitwork5.png";
import HIWA from "../../assets/images/howitworksarrow.png";

export const HowItWorks = () => {
  return (
    <>
      <div className="w-[80%] max-w-[1280px] xs:h-[150px] md:h-[350px] rounded-[30px] bg-[#0061fc] mx-auto flex flex-col sm:hidden xs:hidden md:block ">
        <h3 className="uppercase text-center text-white xs:mt-[15px] md:mt-[30px] xs:text-[15px] xs:leading-[15px] md:text-[25px] md:leading-[25px] font-bold flex items-center justify-center">
          How it Works
        </h3>
        <br />
        <div className="flex flex-row items-center justify-center flex-1 xs:w-[95%] md:w-[80%] mx-auto">
          <div className="flex md:flex-1 items-center justify-center text-white xs:text-[9px] md:text-sm text-center flex-col xs:gap-[0px] md:gap-[50px] xs:w-[55px] xs:leading-[9px]">
            <div className="xs:h-[30px] md:h-[50px]">
              <img src={HIW3} className="xs:w-[20px] md:w-[50px]" />
            </div>
            Create an Account
          </div>

          <div className="flex  items-center justify-center text-white text-sm text-center flex-col xs:gap-[0px] md:gap-[50px]">
            <img src={HIWA} className="xs:w-[15px] md:w-[50px]" />
          </div>

          <div className="flex md:flex-1 items-center justify-center text-white xs:text-[9px] md:text-sm text-center flex-col xs:gap-[0px] md:gap-[50px] xs:w-[55px] xs:leading-[9px]">
            <div className="xs:h-[30px] md:h-[50px]">
              <img src={HIW4} className="xs:w-[20px] md:w-[50px]" />
            </div>
            Select an Algo
          </div>

          <div className="flex  items-center justify-center text-white text-sm text-center flex-col xs:gap-[0px] md:gap-[50px]">
            <img src={HIWA} className="xs:w-[15px] md:w-[50px]" />
          </div>

          <div className="flex md:flex-1 items-center justify-center text-white xs:text-[9px] md:text-sm text-center flex-col xs:gap-[0px] md:gap-[50px] xs:w-[55px] xs:leading-[9px]">
            <div className="xs:h-[30px] md:h-[50px]">
              <img src={HIW5} className="xs:h-[20px] md:h-[50px]" />
            </div>
            Hit the ADD Button
          </div>

          <div className="flex  items-center justify-center text-white text-sm text-center flex-col xs:gap-[0px] md:gap-[50px]">
            <img src={HIWA} className="xs:w-[15px] md:w-[50px]" />
          </div>

          <div className="flex md:flex-1 items-center justify-center text-white xs:text-[9px] md:text-sm text-center flex-col xs:gap-[10px] md:gap-[30px] xs:w-[55px] xs:leading-[9px]">
            <div className="rounded-full md:p-[20px]">
              <img src={HIW2} className="xs:w-[20px] md:w-[50px]" />
            </div>
            <div>
              Choose how much
              <br />
              to allocate
            </div>
          </div>

          <div className="flex  items-center justify-center text-white text-sm text-center flex-col xs:gap-[0px] md:gap-[50px]">
            <img src={HIWA} className="xs:w-[15px] md:w-[50px]" />
          </div>

          <div className="flex md:flex-1 items-center justify-center text-white xs:text-[9px] md:text-sm text-center flex-col xs:gap-[10px] md:gap-[30px] xs:w-[55px] xs:leading-[9px]">
            <div className="bg-[#76abff] rounded-full xs:p-[7px] md:p-[20px] xs:mt-[-8px] md:mt-[0px]">
              <img src={HIW1} className="xs:w-[18px] md:w-[50px]" />
            </div>
            <div>
              Or build your own
              <br />
              algorithm
            </div>
          </div>
        </div>
      </div>

      <div className="w-[80%] max-w-[1280px] rounded-[30px] bg-[#0061fc] mx-auto flex flex-col sm:block xs:block md:hidden ">
        <h3 className="uppercase text-center text-white xs:mt-[15px] md:mt-[30px] xs:text-[15px] xs:leading-[15px] md:text-[25px] md:leading-[25px] font-bold flex items-center justify-center">
          How it Works
        </h3>
        <br />
        <div className="flex flex-row items-center justify-around flex-1 xs:w-[95%] md:w-[80%] mx-auto" >

          <div className="flex items-center justify-center text-white xs:text-[14px] md:text-sm text-center flex-col xs:gap-[0px] md:gap-[50px]  xs:leading-[15px]">
            <div className="xs:h-[40px] md:h-[50px]">
              <img src={HIW3} className="xs:w-[40px] md:w-[50px]" />
            </div>
            <p  >
              Create an Account
            </p>
          </div>

          <div className="flex items-center justify-center text-white xs:text-[14px] md:text-sm text-center flex-col xs:gap-[0px] md:gap-[50px]  xs:leading-[15px]">
            <div className="xs:h-[40px] md:h-[50px]">
              <img src={HIW4} className="xs:w-[40px] md:w-[50px]" />
            </div>
            <p>
              Select an Algo
            </p>
          </div>

        </div>
        <br />
        <div className="flex flex-row items-center justify-around flex-1 xs:w-[95%] md:w-[80%] mx-auto" >

          <div className="flex   items-center justify-center text-white xs:text-[14px] md:text-sm text-center flex-col xs:gap-[10px] md:gap-[50px]  xs:leading-[15px]">
            <div className="xs:h-[40px] md:h-[50px]">
              <img src={HIW5} className="xs:h-[40px] md:h-[50px]" />
            </div>
            Hit the ADD Button
          </div>

          <div className="flex  items-center justify-center text-white xs:text-[14px] md:text-sm text-center flex-col xs:gap-[10px] md:gap-[30px]  xs:leading-[15px]">
            <div className="rounded-full md:p-[20px]">
              <img src={HIW2} className="xs:w-[40px] md:w-[50px]" />
            </div>
             Allocate funds
          </div>

        </div>
        <br />

        <div className="flex flex-row items-center justify-center flex-1 xs:w-[95%] md:w-[80%] mx-auto">
          <div className="flex md:flex-1 items-center justify-center text-white xs:text-[14px] md:text-sm text-center flex-col xs:gap-[10px] md:gap-[30px]  xs:leading-[15px]">
            <div className="bg-[#76abff] rounded-full xs:p-[7px] md:p-[20px] xs:mt-[-8px] md:mt-[0px]">
              <img src={HIW1} className="xs:w-[40px] md:w-[50px]" />
            </div>
            <div>
              Or build your own
              <br />
              algorithm
            </div>
          </div>
        </div>
        <br />
      </div>
    </>
  );
};
